import type { TicketsExecutionRuntime } from '../state/tickets/tickets.models';

export function buildTicketExecutionStartRuntime(
  pending: {
    ticket: { id: string; title: string };
    owner: string;
    repo: string;
    routingReason?: string;
    routingConfidence?: number;
  },
  model: string,
): Partial<TicketsExecutionRuntime> {
  return {
    active: true,
    mode: 'ticket',
    ticketId: pending.ticket.id,
    ticketTitle: pending.ticket.title,
    repoFullName: `${pending.owner}/${pending.repo}`,
    model,
    routingReason: pending.routingReason,
    routingConfidence: pending.routingConfidence,
    phase: 'starting',
    startedAt: Date.now(),
    error: undefined,
    pullRequestUrl: undefined,
  };
}
